// eslint-disable-next-line import/no-unresolved
import { TypeAccess } from 'common/interfaces/user.interface';

const canEditAuthorizationGroup = (group) =>
    group.organizations || group.provider || group.environment === TypeAccess.management;

export default canEditAuthorizationGroup;
